import { render, staticRenderFns } from "./kaoshiZj.vue?vue&type=template&id=6d589557&scoped=true"
import script from "./kaoshiZj.vue?vue&type=script&lang=js"
export * from "./kaoshiZj.vue?vue&type=script&lang=js"
import style0 from "./kaoshiZj.vue?vue&type=style&index=0&id=6d589557&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d589557",
  null
  
)

export default component.exports